var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc7Years(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_17288)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5433 8.46446C8.50257 12.9832 4.81871 23.8114 9.22087 32.6188C13.623 41.4263 24.4949 44.9791 33.5356 40.4604C41.0295 36.7147 44.85 28.6217 43.4199 20.9486C43.2325 19.9431 43.8956 18.9761 44.9011 18.7888C45.9065 18.6014 46.8735 19.2645 47.0609 20.2699C48.793 29.5632 44.1674 39.2869 35.1915 43.7733C24.3775 49.1784 11.2526 44.9678 5.90795 34.2747C0.563294 23.5816 5.07348 10.5566 15.8874 5.15153C24.9057 0.643998 35.5171 2.82223 41.901 9.86462C42.5879 10.6224 42.5305 11.7935 41.7727 12.4804C41.015 13.1673 39.8438 13.1098 39.1569 12.3521C33.8864 6.53797 25.0728 4.70103 17.5433 8.46446Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 24C30 23.3627 30.5084 22.8462 31.1355 22.8462H32.8952V21.1613C32.8952 20.5199 33.4069 20 34.0381 20V20C34.6693 20 35.181 20.5199 35.181 21.1613V22.8462H36.8645C37.4916 22.8462 38 23.3627 38 24V24C38 24.6373 37.4916 25.1538 36.8645 25.1538H35.181V26.8387C35.181 27.4801 34.6693 28 34.0381 28V28C33.4069 28 32.8952 27.4801 32.8952 26.8387V25.1538H31.1355C30.5084 25.1538 30 24.6373 30 24V24Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 15H28C26.7778 21.2857 24.8366 27.8571 24.7647 35H20.2353C20.451 29.5714 21.6732 24.1429 22.9673 18.8571H17V15Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_17288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc7Years);
export default __webpack_public_path__ + "static/media/ic_7years.f73f9474fe3ed418e053c8440e85593e.svg";
export { ForwardRef as ReactComponent };